import React, { useEffect, useState } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { FormikRangePicker, FormikSelect, InputSelect, FormikInput } from '../../../components';
import { debounceIndexAdminEmployeesRequest } from '../../../requests/adminEmployees';
import { debounceIndexAdminCompaniesRequest } from '../../../requests/adminCompanies';

const AttendanceLogsFilter = props => {
  const { errors, touched, values, setFieldValue } = props;
  const [employees, setEmployees] = useState([]);
  const [companies, setCompanies] = useState([]);
  const dispatch = useDispatch();

  const fetchEmployees = () => {
    console.log(values.company_id);
    if (values.company_id === '') return;
    debounceIndexAdminEmployeesRequest({
      dispatch,
      params: {
        active: true,
        sort_column: 'name',
        is_dt: false,
        company_id: values.company_id,
        paginate: false,
        select: true
      },
      successCallback: response => {
        const dataToGroupSearch = [...response.data.data];
        setEmployees(response.data.data.length > 0 ? dataToGroupSearch : []);
      }
    });
  };

  const fetchCompanies = (inputValue, callback) => {
    debounceIndexAdminCompaniesRequest({
      dispatch,
      params: { query: inputValue, sort_column: 'business_name', sort_direction: 'asc', paginate: false },
      successCallback: response => {
        if (response.data.data.length > 0) {
          const data = response.data.data.map(_company => ({
            label: _company.business_name,
            value: _company.id
          }));
          setCompanies(data);
          return callback(data);
        }
        return callback([]);
      }
    });
  };

  const initialDefaultValues = (array, attributeId) => {
    const data = array.find(obj => obj.value === attributeId);
    if (data === undefined) return false;
    return data;
  };

  useEffect(fetchEmployees, [values.company_id]);

  return (
    <Form>
      <Row>
        <Col md={3}>
          <Field name="message">
            {({ field }) => (
              <FormikInput
                {...field}
                label="Mensaje"
                placeholder="Buscar por mensaje"
                onChange={e => {
                  setFieldValue(field.name, e.target.value);
                  if (e.target.value) {
                    setFieldValue('company_id', '');
                    setFieldValue('employee_id', '');
                    setFieldValue('rangeDate', '');
                    setFieldValue('startDate', '');
                    setFieldValue('endDate', '');
                  }
                }}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={3}>
          <Field name="company_id">
            {({ field }) => (
              <InputSelect
                {...field}
                abbr={!values.message}
                label="Empresa Facturación"
                placeholder="Seleccione Empresa"
                isClearable
                isDisabled={!!values.message}
                value={initialDefaultValues(companies, field.value)}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                request={fetchCompanies}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                menuPortalTarget={document.body}
              />
            )}
          </Field>
        </Col>
        <Col md={3}>
          <Field name="employee_id">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Trabajador"
                isDisabled={!!values.message || values.company_id === '' || values.company_id === undefined}
                options={employees}
                placeholder="Seleccione un trabajador"
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={3}>
          <Field name="rangeDate">
            {({ field }) => (
              <FormikRangePicker
                {...field}
                name={field.name}
                abbr={!values.message}
                disabled={!!values.message || values.company_id === '' || values.company_id === undefined}
                startDateName="startDate"
                endDateName="endDate"
                startDate={values.startDate}
                endDate={values.endDate}
                showClearDates
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-4 mb-4">
        <Button type="submit">PreVisualizar</Button>
      </div>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  message: Yup.string().nullable(),
  rangeDate: Yup.array().when('message', {
    is: val => !val,
    then: Yup.array()
      .required('Debes seleccionar un rango de fechas')
      .rangedate(true),
    otherwise: Yup.array().nullable()
  }),
  company_id: Yup.string().when('message', {
    is: val => !val,
    then: Yup.string()
      .required('Debes seleccionar una empresa')
      .nullable(),
    otherwise: Yup.string().nullable()
  })
});
const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default withFormik({
  mapPropsToValues: () => ({
    message: '',
    rangeDate: '',
    company_id: '',
    employee_id: ''
  }),
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(AttendanceLogsFilter);
